import axios from 'axios'
import config from '../config'

/**
 * requestConfig: {
    path: '/api/miniuploader/v1/upload/token',
    method: 'POST',
    data: { usage: usage },
    success: function (res) {
      successCallback && successCallback(res)
    },
    fail: function (msg) {
      failCallback && failCallback(msg)
    }
  }
 */
export default {
  verifiedRequest (requestConfig) {
    if (!requestConfig.method) {
      console.error('API function call requires method argument')
      return
    }
    if (!requestConfig.path) {
      console.error('API function call requires uri argument')
      return
    }
    let accessToken = window.localStorage.getItem('token')
    if (!accessToken) {
      window.alert('认证过期，请刷新页面重新登陆')
      return
    }

    var axiosContext = {
      url: requestConfig.path,
      method: requestConfig.method,
      baseURL: config.serverURI,
      headers: {'Access-Token': accessToken}
    }
    if (requestConfig.method.toLowerCase() === 'get') {
      axiosContext.params = requestConfig.data
    } else {
      axiosContext.data = requestConfig.data
    }
    var promise = axios(axiosContext).then(function (response) {
      let res = response.data
      if (res['status'] === 'ok') {
        if (requestConfig.success) {
          requestConfig.success(res['data'])
        }
      } else if (res['status'] === 'access_token_expired') {
        window.localStorage.removeItem('token')
        window.alert('认证过期，请刷新页面重新登陆')
      } else {
        if (requestConfig.fail) {
          requestConfig.fail(res['msg'])
        } else {
          window.alert(res['msg'])
        }
      }
    }).catch(function (error) {
      if (error.response) {
        // The request was made and the server responded with a status code
        // that falls out of the range of 2xx
        console.log(error.response.data)
        console.log(error.response.status)
        console.log(error.response.headers)
        window.alert('请求失败：' + error.response.status)
      } else if (error.request) {
        // The request was made but no response was received
        // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
        // http.ClientRequest in node.js
        console.log(error.request)
        window.alert('服务器无响应')
      } else {
        // Something happened in setting up the request that triggered an Error
        console.log('Error', error.message)
      }
      console.log(error.config)
    })
    return promise
  }
}



// WEBPACK FOOTER //
// ./src/service/base.js